import { render, staticRenderFns } from "./calificaciones.vue?vue&type=template&id=6b71c7a6"
import script from "./calificaciones.vue?vue&type=script&lang=js"
export * from "./calificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports